export default "__VITE_ASSET__CVKsmgn___"